module.exports = __webpack_public_path__ + "img/slider2.7e41732f.png";